import { useMutation } from 'urql';
import envConfig from '../../../src/config';
import { graphql } from '../../gql';

import { getCookie } from '../../helper/cookie';
import { publicGraphqlClient } from '../../helper/graphql-client';

const LoginMutation = graphql(`
  mutation loginJwt($email: String!, $password: String!) {
    loginJwt(email: $email, password: $password) {
      token
      jwt
      id
      companies {
        cod
      }
    }
  }
`);

export const asyncLogin = (email: string, password: string) => {
  return publicGraphqlClient.mutation(LoginMutation, { email, password }).toPromise();
};

export const useLoginMutation = () => useMutation(LoginMutation);

const RecoverPasswordMutation = graphql(`
  mutation recoverPassword($email: String!) {
    recoverPassword(email: $email) {
      status
      message
    }
  }
`);

export const asyncRecoverPassword = (email: string) => {
  return publicGraphqlClient.mutation(RecoverPasswordMutation, { email }).toPromise();
};

export const useRecoverPasswordMutation = () => useMutation(RecoverPasswordMutation);

export const changePassword = () => {
  const token = getCookie('session_token');
  const userID = getCookie('user_id');
  return fetch(`${envConfig.API_URL_NOVA}/site-auth-api/user/${userID}/password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Token: token,
      Iduser: userID,
    },
  })
    .then((data) => {
      if (data.status >= 400) {
        throw new Error('erro details');
      }

      return Promise.resolve();
    })
    .catch((err) => Promise.reject(err));
};

export const recoverPassword = async (token: string, userId: string, payload: { password: string }) => {
  const response = await fetch(`${envConfig.API_URL_NOVA}/site-auth-api/user/${userId}/password/reset`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Token: token,
      Iduser: userId,
    },
    body: JSON.stringify(payload),
  });

  if (response.status >= 400) {
    throw new Error('erro details');
  }
};

export const workWithUs = async (payload: { name: string; email: string; message: string }) => {
  const response = await fetch(`${envConfig.API_URL_NOVA}/site-auth-api/user/work-with-us`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (response.status >= 400) {
    throw new Error('erro details');
  }
};
